import { MetricCardIcon } from '../MetricCardIcon';
import styles from './MetricCard.module.css';
import { IconName } from '../../ui/Icon/Icon';

type MetricCardProps = {
  iconName: IconName;
  title: string;
  value: string;
};

export const MetricCard = ({ iconName, title, value }: MetricCardProps) => {
  return (
    <div className={styles.metricCardRoot}>
      <div className={styles.metricCardBody}>
        <div className={styles.metricCardIconContainer}>
          <MetricCardIcon iconName={iconName} />
        </div>
        <span className={styles.metricCardTitle}>{title}</span>
        <span className={styles.metricCardValue}>{value}</span>
      </div>
    </div>
  );
};
